import React from 'react'
import arrow from '../../assets/backtotop/arrow.svg'
import { useTranslation } from "react-i18next";

import './BackToTop_Styles.css'

function BackToTop() {
    const { t } = useTranslation();
    const HandleClick = () => {
        window[`scrollTo`]({top: 0, behavior: `smooth`})
    }
    return (
        <div className="container-to-top">
            <div className="box-to-top" onClick= { HandleClick }>
                <img src={ arrow } alt="arrow_back_to_top" />
                <p className="text-arrow">{t("back_to_top.title")}</p>
            </div>
        </div>
    )
}

export default BackToTop
